import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const createBooking = (payload) => api.post('/bookings', payload).then((r) => r.data);
export const createContact = (payload) => api.post('/contact', payload).then((r) => r.data);
export const getQuote = (payload) => api.post('/quote', payload).then((r) => r.data);
export const createCheckoutSession = (payload) =>
  api.post('/checkout/session', payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

// ==== Admin ====
const ADMIN_STORAGE_KEY = 'luxe_admin_passcode';
export const getAdminPasscode = () =>
  typeof window !== 'undefined' ? window.localStorage.getItem(ADMIN_STORAGE_KEY) || '' : '';
export const setAdminPasscode = (p) => window.localStorage.setItem(ADMIN_STORAGE_KEY, p);
export const clearAdminPasscode = () => window.localStorage.removeItem(ADMIN_STORAGE_KEY);
const adminHeaders = () => ({ 'X-Admin-Passcode': getAdminPasscode() });

export const adminLogin = (passcode) =>
  api.post('/admin/login', { passcode }).then((r) => r.data);
export const listBookings = () =>
  api.get('/bookings', { headers: adminHeaders() }).then((r) => r.data);
export const listContact = () =>
  api.get('/contact', { headers: adminHeaders() }).then((r) => r.data);
export const adminConfirmBooking = (id) =>
  api.post(`/admin/bookings/${id}/confirm`, {}, { headers: adminHeaders() }).then((r) => r.data);
export const adminDeclineBooking = (id) =>
  api.post(`/admin/bookings/${id}/decline`, {}, { headers: adminHeaders() }).then((r) => r.data);
export const adminMarkDepositPaid = (id) =>
  api.post(`/admin/bookings/${id}/mark-deposit-paid`, {}, { headers: adminHeaders() }).then((r) => r.data);
